// import { createSelector } from 'reselect'
import { createSelector } from 'reselect';

export const getUploads = state => state.youtube.uploads;

export const get5MostRecentUploads = createSelector(
  [getUploads],
  uploads => {
    // return uploads;
    const orderedUploads = uploads.sort(function compare(a, b) {
      var dateA = new Date(a.addedAt);
      var dateB = new Date(b.addedAt);
      return dateA - dateB;
    });

    return orderedUploads.slice(0, 5);
  }
);



// WEBPACK FOOTER //
// ./src/store/selectors/youtube.js